import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { auth0 } from '@/shared/config';
import { queryClient } from '@/shared/lib/tanstack-query';
import App from './App';
// Initialize i18n before React renders so the first paint is already localized.
import './i18n';
import './index.css';
import { initializeAnalytics } from './utils/analytics';
import { viewportManager } from './utils/viewport';

// Initialize analytics with consent check
// This will only initialize if user has given consent
initializeAnalytics();

// Initialize viewport manager for Android orientation fix and PWA support
// This handles orientation changes in both web browser and installed PWA modes
viewportManager.initialize();

if (import.meta.env.MODE === 'test') {
  (
    window as unknown as {
      __DONVIO_E2E_QUERY_CLIENT__?: typeof queryClient;
    }
  ).__DONVIO_E2E_QUERY_CLIENT__ = queryClient;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Auth0Provider
        domain={auth0.domain}
        clientId={auth0.clientId}
        authorizationParams={{
          redirect_uri: `${window.location.origin}/auth/callback`,
          audience: auth0.audience,
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
        onRedirectCallback={(appState) => {
          // Store pending plan ID for AuthCallback to consume
          // This bridges appState from Auth0 to the AuthCallback component
          if (appState?.pendingPlanId) {
            sessionStorage.setItem('auth0_pending_plan', appState.pendingPlanId);
          }
          // Store provider intent for AuthCallback to forward to PostLogin
          if (appState?.providerIntent) {
            sessionStorage.setItem('auth0_provider_intent', 'true');
          }
        }}
      >
        <App />
      </Auth0Provider>
    </QueryClientProvider>
  </React.StrictMode>,
);
